import angular from 'angular';
import template from './autocomplete.html';
import './autocomplete.scss';
// https://github.com/bevacqua/fuzzysearch/blob/master/index.js
function fuzzysearch(needle, haystack) {
    var hlen = haystack.length;
    var nlen = needle.length;
    if (nlen > hlen) {
        return false;
    }
    if (nlen === hlen) {
        return needle === haystack;
    }
    outer: for (var i = 0, j = 0; i < nlen; i++) {
        var nch = needle.charCodeAt(i);
        while (j < hlen) {
            if (haystack.charCodeAt(j++) === nch) {
                continue outer;
            }
        }
        return false;
    }
    return true;
}
function _ensureHighlightVisible(container, choices, activeIndex) {
    if (choices.length < 1) {
    }
    if (activeIndex < 0) {
        return;
    }
    var highlighted = choices[activeIndex];
    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
    var height = container[0].offsetHeight;
    if (posY > height) {
        container[0].scrollTop += posY - height;
    }
    else if (posY < highlighted.clientHeight) {
        if (activeIndex === 0)
            container[0].scrollTop = 0;
        //To make group header visible when going all the way up
        else
            container[0].scrollTop -= highlighted.clientHeight - posY;
    }
}
class AutocompleteController {
    /* @ngInject */
    constructor($timeout, $element) {
        this.$timeout = $timeout;
        this.$element = $element;
        this.uid = `autocomplete-${Math.random().toString(36).slice(2, 10)}`;
        this.visibleItems = [];
        this.currentIndex = 0;
    }
    $onInit() {
        const listContainer = angular.element(this.$element[0].querySelector('.autocomplete__list'));
        const onKeyDown = (event) => {
            const keyName = event.key;
            if (!['Enter', 'ArrowDown', 'ArrowUp', 'Escape'].includes(keyName)) {
                return;
            }
            void this.$timeout(() => {
                const elements = this.$element[0].querySelectorAll('.autocomplete__button');
                if (keyName === 'Escape') {
                    if (!this.isListOpen()) {
                        return;
                    }
                    this.closeList();
                    return;
                }
                if (this.visibleItems.length === 0) {
                    this.currentIndex = 0;
                    return;
                }
                if (keyName === 'Enter') {
                    if (this.currentIndex >= 0) {
                        this.selectItemFromList(this.visibleItems[this.currentIndex]);
                    }
                    return;
                }
                if (this.visibleItems.length === 1) {
                    this.currentIndex = 0;
                    return;
                }
                if (keyName === 'ArrowDown') {
                    if (this.currentIndex + 1 === this.visibleItems.length) {
                        return;
                    }
                    this.currentIndex++;
                    _ensureHighlightVisible(listContainer, elements, this.currentIndex);
                    return;
                }
                if (keyName === 'ArrowUp') {
                    if (this.currentIndex - 1 === -1) {
                        return;
                    }
                    this.currentIndex--;
                    _ensureHighlightVisible(listContainer, elements, this.currentIndex);
                }
            });
        };
        document.addEventListener('keydown', onKeyDown, false);
        this.removeKeydownListener = () => document.removeEventListener('keydown', onKeyDown, false);
    }
    $onDestroy() {
        this.removeKeydownListener?.();
    }
    isListOpen() {
        return this.visibleItems.length > 0;
    }
    activeOptionId() {
        return !this.isListOpen() ||
            this.currentIndex < 0 ||
            this.currentIndex >= this.visibleItems.length
            ? undefined
            : `${this.uid}-option-${this.currentIndex}`;
    }
    closeList() {
        this.visibleItems = [];
        this.currentIndex = -1;
    }
    onFocus() {
        this.currentIndex = 0;
        this.updateSelect();
    }
    getItemName(item) {
        return this.itemToStr ? this.itemToStr(item) : item.name;
    }
    clickOutside() {
        this.closeList();
        // TODO need to discuss
        if (this.selectedItem &&
            this.getItemName(this.selectedItem) !== this.value) {
            this.value = '';
            this._selectItem(null);
        }
    }
    updateSelect() {
        this.currentIndex = 0;
        if (this.value) {
            this.visibleItems = this.items.filter((item) => {
                if (this.exactSearch)
                    return (this.getItemName(item)
                        .toLowerCase()
                        .indexOf(this.value.toLowerCase()) > -1);
                return fuzzysearch(this.value.toLowerCase(), this.getItemName(item).toLowerCase());
            });
            const fullMatchItem = this.visibleItems.find((item) => this.getItemName(item) === this.value);
            this.selectFromInput(fullMatchItem);
        }
        else {
            this.visibleItems = this.items;
        }
    }
    selectFromInput(item) {
        this._selectItem(item);
    }
    selectItemFromList(item) {
        this.onSelectFromList({ item });
        this._selectItem(item);
        this.value = this.getItemName(item);
        this.closeList();
    }
    _selectItem(item) {
        this.selectedItem = item;
        this.onSelect({ item });
    }
}
const autocomplete = {
    template,
    bindings: {
        items: '<',
        onSelect: '&',
        onSelectFromList: '&',
        itemToStr: '<?',
        placeholder: '<?',
        label: '<?',
        exactSearch: '<?',
    },
    controller: AutocompleteController,
};
export default autocomplete;
